import React, { FunctionComponent, useState } from 'react';
import { FaChevronDown, FaChevronRight, FaRegFolder, FaRegFolderOpen } from 'react-icons/fa6';
import MeetingList from '../MeetingList';
import { IMeetingFoldersProps } from './types';

const MeetingFolders: FunctionComponent<IMeetingFoldersProps> = ({ meetingFolders, onSelect }) => {
  const [openFolders, setOpenFolders] = useState<string[]>([]);

  const toggleFolder = (folderId: string) => {
    if (openFolders.includes(folderId)) {
      return setOpenFolders(openFolders.filter((id) => id !== folderId));
    }
    return setOpenFolders([...openFolders, folderId]);
  };
  return (
    <ul>
      {meetingFolders.map((folder) => {
        const isOpen = openFolders.includes(folder.id);
        const ChevronIcon = isOpen ? FaChevronDown : FaChevronRight;
        const FolderIcon = isOpen ? FaRegFolderOpen : FaRegFolder;

        return (
          <React.Fragment key={folder.id}>
            <li
              className="flex align-center justify-between link p-2"
              style={{ height: 50 }}
              onClick={() => toggleFolder(folder.id)}
            >
              <div className="flex align-center">
                <ChevronIcon className="mr-1" color="#66717c" />
                <FolderIcon size="23" width="25" />
                <span className="ml-1">{folder.name}</span>
              </div>
            </li>
            {isOpen && (
              <li>
                <ul className="pl-4">
                  <MeetingList meetings={folder.meetings} onSelect={onSelect} />
                </ul>
              </li>
            )}
          </React.Fragment>
        );
      })}
    </ul>
  );
};
export default MeetingFolders;
